module.exports = __webpack_public_path__ + "img/full0-min.047d3b0d.png";